import { Component, Input, OnInit, inject } from "@angular/core";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { TicketCompletionCodeStore } from "@app/services/store/ticket-completion-code-store";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { Priority } from "@app/models/rest/priority";
import { ColorChooserComponent } from "@app/view/shared/color-chooser/color-chooser.component";
import { TicketCompletionCode } from "@app/models/rest/ticket-completion-code";
import { Column, Model } from "@bryntum/engine-thin";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-ticket-completion-code-list",
  templateUrl: "./ticket-completion-code-list.component.html",
  styleUrls: ["./ticket-completion-code-list.component.css"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class TicketCompletionCodeListComponent
  extends BaseDataTablePageDirective<TicketCompletionCode>
  implements OnInit
{
  protected ticketCompletionCodeStore: TicketCompletionCodeStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public columns: object[] = [
    {
      type: "template",
      cellMenuItems: [
        {
          text: "Edit Colour Scheme",
          icon: "b-fa b-fa-palette",
          onItem: this.colorChooser.bind(this)
        }
      ],
      id: "colour-column",
      template: ({ record }) =>
        `<div style="
background-color: ${record.get("backgroundColor")};
color: ${record.get("foregroundColor")};
position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    cursor: pointer;
">Preview</div>`
    },
    {
      field: "followOnRequired",
      text: "Follow On Required",
      flex: 1,
      editor: true,
      type: "check"
    },
    {
      field: "code",
      text: "Code",
      flex: 1,
      editor: true
    },
    {
      field: "description",
      text: "Description",
      flex: 3,
      editor: true
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const ticketCompletionCodeStore = inject(TicketCompletionCodeStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      ticketCompletionCodeStore,
      store,
      dialog,
      "TicketCompletionCode",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );
    this.ticketCompletionCodeStore = ticketCompletionCodeStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;

    this.colorChooser = this.colorChooser.bind(this);
    this.onCellClick = this.onCellClick.bind(this);
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  colorChooser(data: { record: Priority }) {
    console.log("item clicked", data);
    let dialogRef = this.dialog.open(ColorChooserComponent, {
      data: {
        currentBackground: data.record.backgroundColor,
        currentForeground: data.record.foregroundColor
      }
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value.success) {
        data.record.backgroundColor = value.backgroundColor;
        data.record.foregroundColor = value.foregroundColor;
      }
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  gridTotalChange($event: any) {
    console.log("total change");
    console.log($event);
  }

  addRow() {
    this.gridStore.insert(0, {
      code: "",
      followOnRequired: false,
      description: "",
      backgroundColor: "#FFFFFF",
      foregroundColor: "#000000"
    });
  }

  onCellClick(event: { record: Model; column: Column }) {
    if (event.column.id === "colour-column") {
      this.colorChooser({ record: event.record });
    }
  }

  debug() {
    console.log(this.gridStore.changes);
  }
}
